import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import { useSelector } from "react-redux";
import { avantSolarApi } from "api/authApi";
import Alert from "components/alert";
import DataTableAvantSolar from "components/datatable/datatable";
import { obtenerNombreHuertaId } from "utils/generalFunctions";
import Footer from "components/Footer/Footer";

var ps;

function ListadoContadores(props) {
  const mainPanel = React.useRef();
  const location = useLocation();
  const [contadores, setContadores] = useState([]);
  const [contadoresCopia, setContadoresCopia] = useState();
  const { user, jwt } = useSelector((state) => state.auth);
  const { huerta } = useSelector((state) => state.dataApp);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    ps = new PerfectScrollbar(mainPanel.current);
    document.body.classList.toggle("perfect-scrollbar-on");

    return function cleanup() {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    };
  });

  useEffect(() => {
    fetchEnergyMeters();
  }, [huerta]);

  const fetchEnergyMeters = async () => {
    setError(null);
    setLoading(true);
    try {
      const response = await avantSolarApi.get(
        "/admins/counterList?id_huerta=" + huerta,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + jwt,
          },
        }
      );

      let data = response.data;

      setLoading(false);
      console.log(data);
      if (data?.code == 200) {
        setContadores([...data.data]);
        setContadoresCopia([...data.data]);
      } else {
        setContadores(null);
        setContadoresCopia(null);
        setError(data.message);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
  };

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  let est = 0.95;

  const headers = [
    [
      "Contador",
      "Potencia Actual (KWh)",
      `E.Tot (EST 0.95)`,
      "Rend (WA/WP)",
      "Potencia (Wp)",
      "Última actualización",
    ],
  ];
  const headersTable = [
    { name: "Contador", prop: "nombreContador" },
    { name: "Potencia Actual (KWh)", prop: "potenciaActual" },
    { name: `E.Tot (EST 0.95)`, prop: "eTot" },
    { name: "Rend (WA/WP)", prop: "rendimiento" },
    { name: "Potencia (Wp)", prop: "potencia" },
    { name: "Última actualización", prop: "fecha" },
  ];

  const properties = [
    "nombreContador",
    "potenciaActual",
    "eTot",
    "rendimiento",
    "potencia",
    "fecha",
  ];

  return (
    <div className="wrapper">
      <Sidebar {...props} routes={routes} />
      <div className="main-panel" ref={mainPanel}>
        <div>
          <DemoNavbar {...props} />
          <div className=" ">
            {!error && (
              <DataTableAvantSolar
                data={contadores}
                dataCopy={contadoresCopia}
                setData={setContadores}
                titleProps={
                  "Listado de Contadores - Huerta: " +
                  obtenerNombreHuertaId(huerta)
                }
                headers={headers}
                headersTable={headersTable}
                name={"listadoContadores"}
                properties={properties}
                filtros={["nombreContador", "nombreTitular"]}
                placeholderInput={"Filtra por Titular o Contador"}
                defaultMostrar={40}
                loading={loading}
                botonesFiltrado={false}
              ></DataTableAvantSolar>
            )}
            {error && <Alert message={error} />}
          </div>
        </div>
        <Footer data={contadoresCopia} />
      </div>
    </div>
  );
}

export default ListadoContadores;
